<form [formGroup]="addToCartForm" (ngSubmit)="onSubmit()">
  <div class="add-to-cart">
    @if (showQuantitySelector) {
      <select
        data-testid="quantitySelector"
        class="add-to-cart__units-selector"
        aria-label="Select quantity"
        i18n-aria-label="@@product.addToCartQuantitySelector"
        formControlName="quantity"
        (change)="resetButton()"
      >
        @for (quantity of quantityArray; track quantity) {
          <option [ngValue]="quantity">{{ quantity }}</option>
        }
      </select>
    }
    <button
      type="submit"
      class="add-to-cart__button btn btn-primary"
      tabindex="0"
      [ngClass]="{ 'btn-sm': small, disabled: !isButtonEnabled }"
      [attr.aria-disabled]="!isButtonEnabled"
      [attr.aria-describedby]="!isButtonEnabled ? 'availability-msg-' + productId : null"
      (click)="isButtonEnabled ? null : $event.preventDefault()"
    >
      @if (!loading) {
        @if (cartProduct && cartProduct!.stock > 0) {
          @if (!small) {
            <span i18n="@@product.addToCart">Add to cart</span>
          } @else {
            <span i18n="@@product.addToCart.short">Add</span>
          }
        }
        @if (cartProduct && cartProduct!.stock === 0) {
          @if (!small) {
            <span i18n="@@product.notAvailable">No longer available</span>
          } @else {
            <span i18n="@@product.notAvailable.short">No longer available</span>
          }
        }
      } @else {
        <span i18n="@@loading">Loading...</span>
      }
    </button>
    @if (!isButtonEnabled) {
      <p [id]="'availability-msg-' + productId" role="alert" class="sr-only" i18n="@@product.notAvailable.msg">
        This product is currently unavailable.
      </p>
    }
  </div>
</form>
